import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiLoginNameInputComponent } from '@fi-app/authenticate/login/login-name-input/login-name-input.component';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { MatInputModule } from '@angular/material/input';
import { FiCountriesMenuModule } from '@fi-app/utilities/fi-countries-menu/fi-countries-menu.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        FiAppTextSharedModule,
        FiErrorMessageModule,
        FiCountriesMenuModule,
    ],
    declarations: [FiLoginNameInputComponent],
    exports: [FiLoginNameInputComponent],
})
export class FiLoginNameInputModule {}
